import { ClientsPage } from "./ClientsPage";

export const Dashboard = () => <ClientsPage />;
